import { Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PHOTO_STORIES } from "@/lib/content";

export const PhotoStories = () => (
  <section className="py-16" data-testid="gallery-photo-stories">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="overline mb-4" style={{ color: "var(--gold)" }}>In their words</p>
        <h2 className="font-display text-4xl md:text-5xl mb-10" style={{ color: "var(--navy)" }}>Parent stories</h2>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {PHOTO_STORIES.map((s, i) => (
          <Reveal key={s.label} delay={(i % 4) * 0.08}>
            <figure className="group h-full flex flex-col rounded-2xl overflow-hidden border bg-white" style={{ borderColor: "rgba(212,175,55,0.3)" }} data-testid={`photo-story-${i}`}>
              <div className="overflow-hidden aspect-[4/5]">
                <img src={s.src} alt={s.label} className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
              </div>
              <figcaption className="p-6 flex flex-col flex-1">
                <Quote size={20} style={{ color: "var(--gold)" }} />
                <p className="font-body font-light text-sm leading-relaxed mt-3 flex-1" style={{ color: "var(--muted)" }} data-testid={`photo-story-quote-${i}`}>“{s.quote}”</p>
                <p className="overline mt-5" style={{ color: "var(--navy)" }}>A Mimi &amp; Me parent</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
